import { render, staticRenderFns } from "./TopBarAdmin.vue?vue&type=template&id=6df2e799&scoped=true&"
import script from "./TopBarAdmin.vue?vue&type=script&lang=js&"
export * from "./TopBarAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TopBarAdmin.vue?vue&type=style&index=0&id=6df2e799&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df2e799",
  null
  
)

export default component.exports